<div *ngIf="plan$ | async as newSubscription" class="flex flex-col" style="gap: 24px">
  <div class="flex flex-col" style="gap: 12px">
    <sbnb-hero-card [emphasized]="true">
      <div class="flex justify-between items-center" style="gap: 6px">
        <div class="flex-1">
          <h2 style="margin-bottom: 12px">
            {{ newSubscription.plan }}
          </h2>
          <div class="feature-grid" *ngIf="newPlanHost$ | async">
            <div *ngFor="let feature of hostFeatures">{{ feature }}</div>
          </div>
          <div class="feature-grid" *ngIf="newPlanPro$ | async">
            <strong>Always included:</strong>
            <div *ngFor="let included of proAlwaysIncluded">{{ included }}</div>
          </div>
        </div>
        <div class="flex flex-col" style="gap: 12px">
          <sbnb-price-callout
            [amount]="newSubscription.base_price.formatted_decimal"
            [currency]="newSubscription.base_price.currency"
            per="month"></sbnb-price-callout>
          <sbnb-price-callout
            [amount]="newSubscription.additional_properties.formatted_decimal"
            [currency]="newSubscription.additional_properties.currency"
            per="additional property"
            size="small"
            prefix="+"></sbnb-price-callout>
        </div>
      </div>
    </sbnb-hero-card>
    <div class="flex justify-end w-full"><sbnb-compare-features-link></sbnb-compare-features-link></div>
  </div>
  <!-- Actionable entitlement checks for downgrade -->
  <ng-container *ngIf="downgradeChecks$ | async as entitlements">
    <sbnb-alert-card context="warning" *ngIf="entitlements?.length" class="flex-col gap-6">
      <span class="text__large strong">Before you switch plans:</span>

      <sbnb-downgrade-warning
        *ngFor="let entitlement of entitlements"
        [entitlement]="entitlement"></sbnb-downgrade-warning>
    </sbnb-alert-card>
  </ng-container>

  <div class="plan-detail-container flex" style="gap: 96px; padding: 0 24px">
    <div class="flex flex-col" style="gap: 24px">
      <ng-container *ngIf="pendingSubscriptionChange$ | async as pending">
        <div class="text__large" *ngIf="pending.isDowngrade">What will change:</div>
      </ng-container>

      <!-- If you're downgrading from Mogul -->
      <ng-container *ngIf="subscription$ | async as currentSubscription">
        <div
          *ngIf="currentSubscription.plan.name === 'mogul' && (newPlanMogul$ | async) === false"
          class="grid items-center"
          style="grid-template-columns: 20px 1fr; gap: 16px">
          <sbnb-icon icon="cancel"></sbnb-icon>
          <strong>Cannot configure Owner Statements for more than 1 Property</strong>

          <sbnb-icon icon="cancel"></sbnb-icon>
          <strong>Cannot connect your Accounting software to Owner Statements</strong>
        </div>
      </ng-container>

      <div class="text__large" *ngIf="newPlanPro$ | async">Everything in Host, plus:</div>

      <div class="grid items-center" style="grid-template-columns: 20px 1fr; gap: 16px">
        <ng-container *ngIf="newPlanMogul$ | async">
          <ng-container *ngFor="let feature of mogulFeatures">
            <sbnb-icon icon="check" class="grass-darker"></sbnb-icon>

            <strong>{{ feature }}</strong>
          </ng-container>

          <div class="text__larger col-span-2 italic">Coming soon</div>

          <ng-container *ngFor="let comingSoon of mogulComgingSoon">
            <sbnb-icon icon="check" class="grass-darker"></sbnb-icon>

            <div class="italic">{{ comingSoon }}</div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="newPlanPro$ | async">
          <ng-container *ngFor="let feature of proFeatures">
            <sbnb-icon icon="check" class="grass-darker"></sbnb-icon>

            <strong>{{ feature }}</strong>
          </ng-container>
          <sbnb-icon icon="check" class="grass-darker"></sbnb-icon>

          <div class="flex flex-col" style="gap: 6px">
            <strong>Managed Smart Locks + Devices</strong>
            <small *ngIf="smartDevicePrice$ | async as smartDevicePrice">
              included: 2 devices for every property + {{ smartDevicePrice.formatted_string }}/ additional device
            </small>
          </div>
          <sbnb-icon icon="check" class="grass-darker"></sbnb-icon>

          <div class="flex flex-col" style="gap: 6px">
            <strong>Direct Bookings + Hosted Site</strong>
            <small>Basic: 1% of booking</small>
            <small>Premium: 4% of booking + payment processing</small>
          </div>
        </ng-container>
        <ng-container *ngIf="newPlanHost$ | async">
          <ng-container *ngFor="let feature of hostLostBenefits">
            <sbnb-icon icon="cancel"></sbnb-icon>

            <strong>{{ feature }}</strong>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="flex flex-col" style="gap: 24px">
      <div class="text__large">Important things to know</div>

      <div class="grid" style="grid-template-columns: 20px 1fr; gap: 12px">
        <sbnb-icon icon="sync" class="text-smoke-darker"></sbnb-icon>
        <strong>Your plan will switch immediately</strong>

        <ng-container *ngIf="subscription$ | async as subscription">
          <span><img src="/assets/iconography/help-documents.svg" /></span>
          <strong *ngIf="subscription.status === 'trialing'">
            Your subscription will start
            {{ subscription.trial_end | date: 'mediumDate' }}
          </strong>
          <strong *ngIf="subscription.status === 'active' || subscription.status === 'pending'">
            Your subscription will renew {{ subscription.current_period_end | date: 'mediumDate' }}
          </strong>
          <strong
            *ngIf="
              subscription.status !== 'trialing' &&
              subscription.status !== 'active' &&
              subscription.status !== 'pending'
            ">
            Your subscription will renew every month.
          </strong>
        </ng-container>

        <span><img src="/assets/iconography/help-documents.svg" /></span>
        <span>
          <strong>Your next monthly cost will be {{ newSubscription.estimated_price?.formatted_string }}</strong>
          <ng-container *ngIf="subscription$ | async as subscription">
            <div
              *ngIf="subscription.discounts?.length || subscription.credits || subscription.taxes?.length"
              class="flex flex-col gap-1 text__small mt-2">
              <!-- Discounts -->
              <ng-container *ngIf="subscription.discounts as discounts">
                <div *ngFor="let discount of discounts">
                  Includes {{ discount.amount }} discount for {{ discount.description }}
                </div>
              </ng-container>

              <!-- Taxes -->
              <ng-container
                *ngIf="
                  subscription.plan.next_amount === newSubscription.estimated_price && subscription.taxes as taxes
                ">
                <div *ngFor="let tax of taxes">
                  Includes {{ tax.amount }} {{ tax.name }} in {{ subscription.country }}
                </div>
              </ng-container>

              <!-- Credits -->
              <ng-container *ngIf="subscription.credits as credits">
                <div>{{ credits.formatted_string }} of credits will be applied</div>
              </ng-container>
            </div>
          </ng-container>
        </span>
      </div>
    </div>
  </div>
</div>
